import apiClient from "../utils/apiClient.util";

export const fetchDraftProjects = async (page = 1, limit = 10, search) => {
  try {
    const offset = page;
    const params = {
      limit,
      offset,
      orderDirection: -1,
      orderField: "createdAt",
      isLive: false,
      search: search !== "" ? search : undefined,
    };

    const response = await apiClient.get("/pro-projects/get", { params });
    return response.data;
  } catch (error) {
    console.error("Fetch draft projects API error:", error);
    throw error;
  }
};
